module.exports = __webpack_public_path__ + "static/vib_play3-dbd68b0edb97e68366ad7af8fed25620.jpg";